import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Impact {
  id: string
  name: string
}

export interface UseImpactsResult {
  impacts: Impact[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useImpacts(fetchOnMount = false): UseImpactsResult {
  const [impacts, setImpacts] = useState<Impact[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ impacts: Impact[] }>('/admin/conversation-management/impacts/dropdown')
      console.log('Impacts response:', res)
      setImpacts(res.impacts || [])
    } catch (e) {
      console.error('Failed to fetch impacts:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch impacts')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { impacts, loading, error, refetch }
}
